"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, TrendingUp, Globe, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const TICKER_ITEMS = [{
  symbol: "BAŞARI",
  value: "%99.8",
  change: "+Premium"
}, {
  symbol: "GARANTİ",
  value: "Ömür Boyu",
  change: "+Güven"
}, {
  symbol: "TEKNOLOJİ",
  value: "3D Tarama",
  change: "+Dijital"
}, {
  symbol: "KONFOR",
  value: "Ağrısız",
  change: "+Sedasyon"
}, {
  symbol: "DENEYİM",
  value: "20+ Yıl",
  change: "+Uzmanlık"
}, {
  symbol: "HASTA",
  value: "10.000+",
  change: "+Mutluluk"
}];
export default function Hero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  const [tickerOffset, setTickerOffset] = useState(0);
  useEffect(() => {
    let animationFrameId: number;
    const animate = () => {
      setTickerOffset(prev => (prev - 0.5) % 100);
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);
  return <section data-section-id="40727" id="implant-tedavisi-kahraman-bölümü" className="relative w-full min-h-[90vh] lg:min-h-screen bg-background text-foreground overflow-hidden flex flex-col lg:flex-row">
      {}
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-20 lg:py-0 z-10 relative">
        <div ref={textRef} className={`transition-all duration-[1200ms] ease-out transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[20px]"}`}>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-[84px] leading-[1.1] font-light mb-6 text-[#2D3436]">
            İmplant <br />
            <span className="text-primary italic">Tedavisi</span>
            <span className="text-primary"></span>
          </h1>

          <p className="font-sans text-base sm:text-lg text-muted-foreground mb-10 max-w-lg tracking-[0.025em] leading-relaxed">Kalıcı bir gülümsemenin lüksünü ve konforunu keşfedin.&nbsp; Modern tekniklerle estetik ve fonksiyonu bir araya getiriyoruz.</p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild className="relative overflow-hidden bg-gradient-to-br from-[#D4AF37] to-[#8C7851] text-white hover:opacity-90 rounded-[2px] h-12 px-8 text-base font-medium group border-none shadow-md">
              <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                <span className="relative z-10 flex items-center gap-2">
                  Randevu Al
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
                {}
                <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0 !w-[753.5px]" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="rounded-[2px] h-12 px-8 text-base font-medium border-primary/40 text-primary hover:bg-primary/5 hover:text-primary hover:border-primary transition-colors bg-transparent">
              
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-1/2 relative h-[50vh] lg:h-auto overflow-hidden bg-muted">
        <div ref={imageRef} className={`w-full h-full transition-opacity duration-[1200ms] ease-in-out ${imageVisible ? "opacity-100" : "opacity-0"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/smiling-patient-implant.png" alt="Smiling patient with implant" className="absolute inset-0 w-full h-full object-cover" />
          
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent lg:bg-gradient-to-l lg:from-transparent lg:to-background/30" />

          {}
          <div className="absolute bottom-12 left-0 w-full bg-background/80 backdrop-blur-md border-y border-primary/10 py-3 overflow-hidden">
            <div className="flex items-center gap-8 whitespace-nowrap w-max">
              {}
              <div className="flex animate-[marquee_30s_linear_infinite] gap-12">
                {[...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => <div key={i} className="flex items-center gap-3 font-mono text-xs tracking-wider" data-index={i}>
                    <span className="text-muted-foreground font-bold">{item.symbol}</span>
                    <span className="text-foreground">{item.value}</span>
                    <span className={`${item.change.startsWith("+") ? "text-primary" : "text-destructive"}`}>
                      {item.change}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          {}
          <div className="absolute top-10 right-10 hidden lg:flex flex-col gap-4 items-end opacity-80">
            <div className="flex items-center gap-2 text-xs font-mono text-primary font-bold">
              <Activity className="w-4 h-4" />
              <span>DİJİTAL TEŞHİS</span>
            </div>
            <div className="flex items-center gap-2 text-xs font-mono text-foreground/80">
              <Globe className="w-4 h-4" />
              <span>TÜRKİYE • KAYSERİ&nbsp;</span>
            </div>
          </div>
        </div>
      </div>

      {}
      <style jsx global>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>;
}